import { HistoryActionTypes } from './actionType';

export const addHistory = (history) => dispatch => {
    dispatch({ type: HistoryActionTypes.ADD_HISTORY, payload: history });
}

export const setIsCMS = (value) => dispatch => {
    dispatch({ type: HistoryActionTypes.IS_CMS, payload: value });
}